import React from "react";
import BaseFormPage from "../../components/BaseFormPage";
import FormHeader from "../../components/FormHeader";
import BaseButton from "../../components/BaseButton";
import BaseInput from "../../components/BaseInput";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function EmailConfirmationPage() {
  const { t } = useTranslation();
  return (
    <div className="confirmation-page">
      <BaseFormPage>
        <FormHeader title={t("confirmation_page.confirmation_title")} />
        <p className="confirmation-page__tip">
          {t("confirmation_page.confirmation_info")}
        </p>
        <BaseButton className="confirmation-page__btn-get-code">
          {t("confirmation_page.get_code_label")}
        </BaseButton>
        <BaseInput
          id="confirmation-code"
          type="text"
          label={t("confirmation_page.code_label")}
        />
        <BaseButton className="confirmation-page__btn-pay">
          {t("go_payment")}
        </BaseButton>
      </BaseFormPage>
    </div>
  );
}
